import type { SourceKind } from "@/api/db/connection";
import { cn } from "@/lib/utils";

type Source = SourceKind;

type AllSources<T extends readonly SourceKind[]> = [SourceKind] extends [T[number]]
	? T
	: ["source missing from ALL_SOURCES", Exclude<SourceKind, T[number]>];

function allSources<const T extends readonly SourceKind[]>(list: AllSources<T>) {
	return list;
}

export const ALL_SOURCES = allSources(["sendpulse", "instagram", "form", "erp", "monday"]);

const SOURCE_STYLE: Record<Source, string> = {
	erp: "bg-primary/10 text-primary border-primary/25",
	sendpulse: "bg-whatsapp/10 text-whatsapp border-whatsapp/30",
	form: "bg-foreground/10 text-foreground border-foreground/25",
	monday: "bg-warning/10 text-warning border-warning/30",
	instagram: "bg-destructive/10 text-destructive border-destructive/30",
};

export const SOURCE_LABEL: Record<Source, string> = {
	erp: "ERP",
	sendpulse: "WhatsApp",
	form: "Cadastro",
	monday: "Monday",
	instagram: "Instagram",
};

export function SourceBadge({ source, className }: { source: Source; className?: string }) {
	return (
		<span className={cn("status-badge border", SOURCE_STYLE[source], className)}>
			{SOURCE_LABEL[source]}
		</span>
	);
}

export function SourceBadges({ sources, className }: { sources: Source[]; className?: string }) {
	return (
		<span className="inline-flex min-w-0 flex-wrap gap-1">
			{sources.map((source) => (
				<SourceBadge key={source} source={source} className={className} />
			))}
		</span>
	);
}
